import React from "react";
import styles from "../../assets/styles/Charge/Charge.module.scss";
import {
  MimaButton,
  MimaDropdown,
  MimaDropZone,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../components";
import { Formik, Field, FieldArray } from "formik";

const CreateNews = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  singleNews,
  isCopied,
}) => {
  const FieldDropDown = ({ field, ...props }) => {
    return <MimaDropdown {...field} {...props} />;
  };

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4}>
        {isCopied ? "Update News" : "Create News"}
      </MimaText>
      <Formik
        initialValues={{
          title: isCopied ? singleNews.title : "",
          text: isCopied ? singleNews.text : "",
          summary: isCopied ? singleNews.summary : "",
          imageUrls: isCopied
            ? singleNews.imageUrls.map((x) => ({
                key: x.key,
                files: [
                  {
                    name: x?.url,
                    preview: x?.url,
                  },
                ],
              }))
            : [
                {
                  key: "",
                  files: [],
                },
              ],
          action: isCopied
            ? singleNews.action
            : {
                url: "",
                buttonTitle: "",
              },
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaInput
              labelTitle="News Title"
              name="title"
              value={values.title}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.title}
              touched={touched.title}
            />

            <MimaTextArea
              labelTitle="News Content"
              name="text"
              value={values.text}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.text}
              touched={touched.text}
            />
            <MimaTextArea
              labelTitle="News Summary"
              name="summary"
              value={values.summary}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.summary}
              touched={touched.summary}
            />
            <FieldArray name="imageUrls">
              {({ push, remove }) => (
                <React.Fragment>
                  {values.imageUrls.map((_, i) => (
                    <div key={i}>
                      <div>
                        <Field
                          name={`imageUrls.${i}.key`}
                          component={FieldDropDown}
                          placeHolder="Sellect image name"
                          placeholder={
                            values.imageUrls?.[i]?.key || "Select name"
                          }
                          data={[
                            { key: "Banner", value: "Banner" },
                            { key: "Content", value: "Content" },
                          ]}
                          onChange={(data) => {
                            setFieldValue(`imageUrls.${i}.key`, data.key);
                          }}
                          labelTitle="Image Name"
                          touched={touched?.imageUrls?.[i]?.key}
                          error={errors?.imageUrls?.[i]?.key}
                        />
                        <div style={{ width: "38rem" }}>
                          <MimaDropZone
                            name={`imageUrls.${i}.files`}
                            title="Upload News Image"
                            info="maximum image Size 1MB"
                            maxNumOfImages={1}
                            files={values?.imageUrls?.[i]?.files}
                            setFiles={(newFiles) => {
                              setFieldValue(`imageUrls.${i}.files`, newFiles);
                            }}
                            labelTitle="Upload Image"
                            errorMsg={errors?.imageUrls?.[i]?.files}
                          />
                        </div>
                      </div>
                      {i !== 0 ? (
                        <MimaButton
                          title="Remove"
                          variant="filter"
                          type="button"
                          buttonColor="var(--color-error)"
                          width={10}
                          onClick={() => remove(i)}
                        />
                      ) : (
                        ""
                      )}
                      <div className={styles.summary__line}></div>
                    </div>
                  ))}
                  <MimaButton
                    title="Add Another Image"
                    variant="text"
                    type="button"
                    onClick={() =>
                      push({
                        key: "",
                        files: [],
                      })
                    }
                    width={38}
                    mb={2}
                  />
                </React.Fragment>
              )}
            </FieldArray>

            <div className="modal__beside">
              <MimaInput
                labelTitle="Action Title"
                name={`action.buttonTitle`}
                value={values.action.buttonTitle}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.action?.buttonTitle}
                touched={touched.action?.buttonTitle}
                width={18}
              />
              <MimaInput
                labelTitle="Action Url"
                name={`action.url`}
                value={values.action.url}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.action?.url}
                touched={touched.action?.url}
                width={18}
              />
            </div>

            <MimaButton
              title="Continue"
              width={38}
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default CreateNews;
